import { setDataKeyPrefix, setRetrievalFunction } from "@swa-ui/bootstrap";

setRetrievalFunction(window.require);
setDataKeyPrefix("swa-bootstrap-inflight-home-page/");
